/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DisciplineGroupGetAllDTO,
    DisciplineGroupGetAllDTOFromJSON,
    DisciplineGroupGetAllDTOFromJSONTyped,
    DisciplineGroupGetAllDTOToJSON,
} from './DisciplineGroupGetAllDTO';

/**
 * 
 * @export
 * @interface DisciplineGroupGetAllDTOPagedResponse
 */
export interface DisciplineGroupGetAllDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof DisciplineGroupGetAllDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DisciplineGroupGetAllDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof DisciplineGroupGetAllDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DisciplineGroupGetAllDTO>}
     * @memberof DisciplineGroupGetAllDTOPagedResponse
     */
    data?: Array<DisciplineGroupGetAllDTO> | null;
}

export function DisciplineGroupGetAllDTOPagedResponseFromJSON(json: any): DisciplineGroupGetAllDTOPagedResponse {
    return DisciplineGroupGetAllDTOPagedResponseFromJSONTyped(json, false);
}

export function DisciplineGroupGetAllDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisciplineGroupGetAllDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(DisciplineGroupGetAllDTOFromJSON)),
    };
}

export function DisciplineGroupGetAllDTOPagedResponseToJSON(value?: DisciplineGroupGetAllDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(DisciplineGroupGetAllDTOToJSON)),
    };
}

